import { useUpdateEffect } from '@lbcamden/lib-react';
import { bcrypt, bcryptVerify } from 'hash-wasm';
import useLocalStorage from 'use-local-storage-state';

export const useClientPinAuthInfo = () => {
  const [hashedPin, storeHashedPin, { removeItem: deleteHashedPin }] =
    useLocalStorage<string>('hashedPin');

  const [username, storeUsername, { removeItem: deleteStoredUsername }] =
    useLocalStorage<string>('username.pin');

  const hashAndStorePin = async (pin: string) => {
    const hash = await bcrypt({
      password: pin,
      salt: crypto.getRandomValues(new Uint8Array(16)),
      costFactor: 11,
      outputType: 'encoded',
    });

    storeHashedPin(hash);
  };

  const verifyPin = async (pin: string) => {
    const isValid =
      !!hashedPin &&
      (await bcryptVerify({
        password: pin,
        hash: hashedPin,
      }));

    if (!isValid) {
      throw Error('Invalid PIN');
    }
  };

  useUpdateEffect(deleteHashedPin, [username]);

  return {
    username,
    storeUsername,
    deleteStoredUsername,
    hashAndStorePin,
    verifyPin,
    hasPin: !!hashedPin,
  };
};
